<template>
  <div>
    <img
      src="../assets/images/absapay.svg"
      alt="Absa pay"
      class="absapay-logo"
    />
  </div>
</template>

<script>
export default {
  name: 'AbsaPayLogo',
}
</script>

<style scoped>
.absapay-logo {
  display: block;
  margin: 0 auto;
  padding-top: 15px;
}
</style>
